import type { FC } from 'react';
import './notification-matrix-card.css';

export type NotificationChannel = 'push' | 'email' | 'sms';
export type NotificationPreferenceMap = Record<string, Record<NotificationChannel, boolean>>;

export interface NotificationMatrixCardProps {
  className?: string;
  figmaNode?: string;
  title?: string;
  subtitle?: string;
  channels?: Array<{ key: NotificationChannel; label: string }>;
  categories: Record<string, string>;
  preferences: NotificationPreferenceMap;
  disabled?: boolean;
  onTogglePreference: (categoryKey: string, channel: NotificationChannel) => void | Promise<void>;
}

const DEFAULT_CHANNELS: Array<{ key: NotificationChannel; label: string }> = [
  { key: 'push', label: 'В кабинете' },
  { key: 'email', label: 'Email' },
  { key: 'sms', label: 'SMS' },
];

export const NotificationMatrixCard: FC<NotificationMatrixCardProps> = ({
  className = '',
  figmaNode,
  title = 'Настройки уведомлений',
  subtitle = 'В кабинете, по email и SMS',
  channels = DEFAULT_CHANNELS,
  categories,
  preferences,
  disabled = false,
  onTogglePreference,
}) => {
  const categoryKeys = Object.keys(categories);

  return (
    <section
      className={`lovo-notification-matrix carrier-notification-settings ${className}`.trim()}
      aria-label={title}
      data-figma-node={figmaNode}
    >
      <header className="lovo-notification-matrix__header">
        <h2>{title}</h2>
        {subtitle ? <span>{subtitle}</span> : null}
      </header>

      <div className="lovo-notification-matrix__channels carrier-notification-settings__channels">
        <span />
        {channels.map((channel) => (
          <b key={channel.key}>{channel.label}</b>
        ))}
      </div>

      {categoryKeys.map((key) => {
        const label = categories[key] ?? key;
        const rowPreferences = preferences[key] ?? { push: false, email: false, sms: false };

        return (
          <div className="lovo-notification-matrix__row carrier-notification-settings__row" key={key}>
            <strong>{label}</strong>
            {channels.map((channel) => (
              <label key={channel.key} className="lovo-notification-matrix__cell carrier-notification-settings__cell">
                <input
                  aria-label={`${label}: ${channel.label}`}
                  checked={Boolean(rowPreferences[channel.key])}
                  disabled={disabled}
                  type="checkbox"
                  onChange={() => void onTogglePreference(key, channel.key)}
                />
              </label>
            ))}
          </div>
        );
      })}
    </section>
  );
};
